import { render, staticRenderFns } from "./CreateCampaignReviewCardGreeting.vue?vue&type=template&id=4fa68760&scoped=true"
import script from "./CreateCampaignReviewCardGreeting.vue?vue&type=script&lang=js"
export * from "./CreateCampaignReviewCardGreeting.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignReviewCardGreeting.vue?vue&type=style&index=0&id=4fa68760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa68760",
  null
  
)

export default component.exports